












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ResultDescription extends Vue {
  @Prop(String) icon: string
  @Prop(String) title: string
}
